'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var ColumnCard = require('./ColumnCard.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className"];
/**
 * ColumnCardIcon
 *
 * Displays the appropriate column card icon depending on card type; or a custom one.
 */
var ColumnCardIcon = react.forwardRef(function (props, ref) {
  var _CARD_TYPES$cardType;
  var _useColumnCardContext = ColumnCard.useColumnCardContext(),
    cardType = _useColumnCardContext.cardType;
  var media = (_CARD_TYPES$cardType = ColumnCard.CARD_TYPES[cardType]) === null || _CARD_TYPES$cardType === void 0 ? void 0 : _CARD_TYPES$cardType.icon;
  var styles = react.useStyles();
  var className = props.className,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  return /*#__PURE__*/React__default["default"].createElement(react.Icon, _extends__default["default"]({
    ref: ref,
    as: media
  }, rest, {
    className: utils.cx('chakra-column-card__icon', className),
    __css: styles.icon
  }));
});
ColumnCardIcon.displayName = 'ColumnCardIcon';
exports.ColumnCardIcon = ColumnCardIcon;